__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "interactions-ui";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@mantine/form", "7.17.8", () => (__webpack_require__.e(46).then(() => (() => (__webpack_require__(6046))))));
			register("@monaco-editor/react", "4.7.0", () => (__webpack_require__.e(158).then(() => (() => (__webpack_require__(7158))))));
			register("@platform/ui-library", "4.9.2", () => (Promise.all([__webpack_require__.e(559), __webpack_require__.e(374), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(1559))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(307).then(() => (() => (__webpack_require__(8307))))));
			register("d3-delaunay", "6.0.4", () => (__webpack_require__.e(197).then(() => (() => (__webpack_require__(197))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(536).then(() => (() => (__webpack_require__(3536))))));
			register("react-dom", "19.0.0", () => (() => (__webpack_require__(7950))), 1);
			register("react-draggable", "4.7.2", () => (Promise.all([__webpack_require__.e(754), __webpack_require__.e(374)]).then(() => (() => (__webpack_require__(6754))))));
			register("react-dropzone", "14.3.5", () => (__webpack_require__.e(580).then(() => (() => (__webpack_require__(4580))))));
			register("react-error-boundary", "5.0.0", () => (__webpack_require__.e(632).then(() => (() => (__webpack_require__(3632))))));
			register("react-pin-field", "4.0.2", () => (__webpack_require__.e(496).then(() => (() => (__webpack_require__(5496))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(907), __webpack_require__.e(374)]).then(() => (() => (__webpack_require__(2907))))));
			register("react-resizable", "3.2.0", () => (Promise.all([__webpack_require__.e(3), __webpack_require__.e(181)]).then(() => (() => (__webpack_require__(5003))))));
			register("react-router-dom", "7.18.4", () => (Promise.all([__webpack_require__.e(289), __webpack_require__.e(367), __webpack_require__.e(374), __webpack_require__.e(254)]).then(() => (() => (__webpack_require__(3367))))));
			register("react-router", "7.18.4", () => (Promise.all([__webpack_require__.e(289), __webpack_require__.e(272)]).then(() => (() => (__webpack_require__(7272))))));
			register("react", "19.0.0", () => (() => (__webpack_require__(5043))), 1);
			register("uuid", "11.1.1", () => (__webpack_require__.e(56).then(() => (() => (__webpack_require__(1056))))));
			register("validator", "13.15.35", () => (__webpack_require__.e(650).then(() => (() => (__webpack_require__(4650))))));
			register("xlsx", "0.18.5", () => (__webpack_require__.e(238).then(() => (() => (__webpack_require__(8857))))));
			register("zustand", "5.0.15", () => (__webpack_require__.e(461).then(() => (() => (__webpack_require__(7461))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};